import React from "react";
import {_t} from "../../../js/translation";

export default ({children: textContent = '', inline, html, ...otherProps}) => 
    html ? (
        inline ? <span dangerouslySetInnerHTML={{__html: _t(textContent, otherProps)}} /> :
            <div dangerouslySetInnerHTML={{__html: _t(textContent, otherProps)}} />
    ) : _t(textContent, otherProps)